import { useState, useEffect } from 'react'
import { RouterProvider } from "react-router-dom";
import router from "./router";
import useAuthStore from "./store/auth.store";

function App() {

  const initAuth = useAuthStore((s) => s.initAuth);
  const loading = useAuthStore((s) => s.loading);
  
  useEffect(() => {
    const saved = localStorage.getItem("theme") || "dark";
    document.documentElement.setAttribute("data-theme", saved);
  }, []);

  useEffect(() => {
    initAuth();
  }, [initAuth]);

  if (loading) return null;

  return <RouterProvider router={router} />;
}

export default App



